import script from "./ShowType.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./ShowType.vue?vue&type=script&lang=js"
export * from "./ShowType.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./ShowType.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"src/SharedWeb/scripts/dynamic-component-editor/standard-components/show-card-small/ShowType.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1685fa6e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1685fa6e', __exports__)) {
    api.reload('1685fa6e', __exports__)
  }
  
}


export default __exports__